module.exports = "/fonts/fa-light-300.svg?5d468eaee7c2858069f7bcbf9b6b71d1";